import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import * as firebase from 'firebase';
import { FornecedorElement } from '../../interfaces/fornecedor';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';
import cnpjVerdadeiro from '../../funcoes/validar.cnpj';
import telefoneVerdadeiro from '../../funcoes/validar.telefone';

@Component({
  selector: 'app-novo-fornecedor',
  templateUrl: './novo-fornecedor.component.html',
  styleUrls: ['./novo-fornecedor.component.scss', '../../styles/estilo.padrao.scss']
})
export class NovoFornecedorComponent implements OnInit {
  uid;
  fornecedorForm: FormGroup;

  enderecos = [];
  auxObservableEnderecos;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
  ) {
    this.uid = localStorage.getItem('uid')
  }

  //Máscaras
  maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskCNPJ = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/];
  maskCEP = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];


  ngOnInit(): void {
    this.fornecedorForm = this.formBuilder.group({
      razaoSocial: ['', [Validators.required]],
      nomeFantasia: ['', [Validators.required]],
      cnpj: ['', [Validators.required, cnpjVerdadeiro]],
      inscricaoEstadual: ['', Validators.required],
      telefone: ['', [Validators.required, telefoneVerdadeiro]],
      telefoneSecundario: ['', null],
      responsavel: ['', Validators.required],
      observacao: ['', null],
      cep: ['', Validators.required],
      logradouro: ['', Validators.required],
      numero: ['', Validators.required],
      complemento: ['', null],
      bairro: ['', Validators.required],
      cidade: ['', Validators.required],
      uf: ['', Validators.required],
      referencia: ['', null],
    });
  }

  async cadastrar() {
    this.spinner.show('default');

    if (this.fornecedorForm.valid) {

      try {
        this.usuarioService.getFornecedorCNPJ(this.f.cnpj.value, this.uid).pipe(take(1)).subscribe(async snap => {
          if (snap.length === 0) {
            const map: FornecedorElement = {
              Status: true,
              RazaoSocial: this.f.razaoSocial.value.trim(),
              NomeFantasia: this.f.nomeFantasia.value.trim(),
              CNPJ: this.f.cnpj.value.trim(),
              InscricaoEstadual: this.f.inscricaoEstadual.value.trim(),
              Telefone: this.f.telefone.value.trim(),
              TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
              Responsavel: this.f.responsavel.value.trim(),
              TimestampCadastro: firebase.default.database.ServerValue.TIMESTAMP,
              Observacao: this.f.observacao.value.trim(),
              CEP: this.f.cep.value.trim(),
              Logradouro: this.f.logradouro.value.trim(),
              Numero: this.f.numero.value.trim(),
              Complemento: this.f.complemento.value.trim(),
              Bairro: this.f.bairro.value.trim(),
              Cidade: this.f.cidade.value.trim(),
              UF: this.f.uf.value.trim(),
              Referencia: this.f.referencia.value.trim(),
            }

            try {
              const resp = await this.usuarioService.setFornecedor(map, this.uid);
              setTimeout(() => {
                this.spinner.hide('default');
                if (resp) {
                  this.usuarioService.setLog("Cadastro de novo fornecedor: " + this.f.nomeFantasia.value.trim() + ' CNPJ: ' + this.f.cnpj.value.trim(), map, this.uid);

                  this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                    this.router.navigate(["/pages/consultar-fornecedor"], { queryParams: { IDFornecedor: resp } }));
                } else {
                  this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                    this.router.navigate(["/pages/novo-fornecedor"]));
                }
              }, 2000);
            } catch (e) {
              console.log(e)
              this.spinner.hide('default');

              this.usuarioService.setLog("Erro no cadastro de novo fornecedor: " + this.f.nomeFantasia.value.trim() + ' CNPJ: ' + this.f.cnpj.value.trim() + '; Erro: ' + e, map, this.uid);

              this.toastr.error('Erro ao cadastrar fornecedor!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/novo-fornecedor"]));
            }

          } else {
            this.spinner.hide('default');
            this.toastr.error('Este CNPJ já consta no sistema!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
          }
        });
      }
      catch (e) {

        this.usuarioService.setLog("Erro ao validar CNPJ fornecedor! " + this.f.nomeFantasia.value.trim() + ' CNPJ: ' + this.f.cnpj.value.trim(), e, this.uid);

        this.toastr.error('Erro ao validar CNPJ fornecedor!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/novo-fornecedor"]))
      }

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.fornecedorForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  async buscarCEP() {
    if (this.f.cep.value.length == 10) {
      const resp: any = await this.usuarioService.getBuscaCEP(this.f.cep.value);
      const dados = resp;

      if (dados.erro) {
        this.toastr.warning("Cep inválido!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.fornecedorForm.get('logradouro').patchValue('');
        this.fornecedorForm.get('complemento').patchValue('');
        this.fornecedorForm.get('bairro').patchValue('');
        this.fornecedorForm.get('cidade').patchValue('');
        this.fornecedorForm.get('uf').patchValue('');
        this.fornecedorForm.get('cidade').enable();
        this.fornecedorForm.get('uf').enable();
      } else {
        this.fornecedorForm.get('logradouro').patchValue(dados.logradouro);
        this.fornecedorForm.get('complemento').patchValue(dados.complemento);
        this.fornecedorForm.get('bairro').patchValue(dados.bairro);
        this.fornecedorForm.get('cidade').patchValue(dados.localidade);
        this.fornecedorForm.get('uf').patchValue(dados.uf);
        this.fornecedorForm.get('cidade').disable();
        this.fornecedorForm.get('uf').disable();
      }
    }
  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/novo-fornecedor"]));
  }

  onChangeTel(e, b) {
    if (e.length >= 6) {
      if (e.substring(5, 6) === '9') {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    } else {
      b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.fornecedorForm.controls; }
}
